import { useState, useEffect, useContext } from 'react';
import './App.css';
import { AdministrationDetail,
		AdministrationList,
		AdministrationView,
		ProductDetail,
		PublicView,
		Login } from "./pages";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './firebase_setup/firebase';
import { DataProvider, TodoContext } from './context/DataProvider';
import { Navbar } from './components';
import { Box } from '@mui/material';
import "react-toastify/dist/ReactToastify.css";

function App() {
	return (
		<DataProvider>
			<AppContent/>
		</DataProvider>
	);
}

function ProtectedRoute({ user, children }) {
	if (!user) {
		return <Navigate to="/" />;
	}
	return children;
}

function AppContent() {

    const { user, setUser } = useContext(TodoContext);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
            setUser(firebaseUser);
        });

        return () => unsubscribe();
    }, []);

    return (
        <Box
            sx={{
                backgroundColor: '#EDEDED',
                height: '100vh',
            }}
        >
            <Router>
                <Navbar userAuth={user}/>
                <Routes>
                    <Route path='/' element={<PublicView/>}/> {/* el login no es una barrera para el rutaje, mas bien para el uso de menu */}
                    <Route path='/init' element={<Login/>}/>
                    <Route path='/detail' element={<ProductDetail/>}/>
                    <Route path='/adminView' element={<ProtectedRoute user={user}> <AdministrationView /> </ProtectedRoute>}/>
                    <Route path='/adminDetail' element={<ProtectedRoute user={user}> <AdministrationDetail/> </ProtectedRoute>}/>
                    <Route path='/adminList' element={<ProtectedRoute user={user}> <AdministrationList/> </ProtectedRoute>}/>
                </Routes>
            </Router>
        </Box>
    )
}

export default App;
